
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17 6.5h3c1.11 0 2 .89 2 2v11c0 1.11-.89 2-2 2H4c-1.11 0-2-.89-2-2v-11c0-1.11.89-2 2-2h3v-2c0-1.11.89-2 2-2h6c1.11 0 2 .89 2 2v2zm-2-2H9v2h6v-2zm5 15H4v-2h16v2zm-16-5h16v-6h-3v2h-2v-2H9v2H7v-2H4v6z","fill":"#585858"}})])
          )
        }
      }
    